import { render, staticRenderFns } from "./MmlStaticPage.vue?vue&type=template&id=b3b59c98&scoped=true&"
import script from "./MmlStaticPage.vue?vue&type=script&lang=js&"
export * from "./MmlStaticPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b59c98",
  null
  
)

export default component.exports